import React, { useState, useEffect, useMemo } from "react";
import Modal from "react-modal";
import BigShowCompleteCard from "../../Card/BigShowCompleteCard";
import { useTranslation } from "react-i18next";
import translations from "../../../utils/language/translations.json";
import axios from "axios";
import { toast } from "react-toastify";
import TradeTransactionCommentFeed from "./TradeTransactionCommentFeed";
import FullCardGrid from "../../GridViewMain/FullCardGrid/FullCardGrid";
 import { useSport } from '../../../utils/SportsProvider';
const ModalTradeOffer = ({
  isOpen,
  onClose,
  thisCurrentCard,
  theirId,
  yourId,
  liveCsrfToken,
  mode,
  offer,
  fetchTradeOffers,
  Status,
  triggerLogin
}) => {
  function mapTradeCard(card, role = "Offer") {
    return {
      ...card,
      ShowName: card[`${role}ShowName`],
      ProfilPicture: card[`${role}ProfilePicture`],
      Country: card[`${role}Country`],
      AverageRating: card[`${role}Rating`],
      NumberOfTransactions: card[`${role}Transactions`],
      ImageFront: card.ImageFront || card.Image,
      IsRookie: card.IsRookie ? "Rookie(RC)" : "",
      IsPatch: card.IsPatch ? "Patch" : "",
      IsJersey: card.IsJersey ? "Jersey" : "",
      IsAuto: card.IsAuto ? "Auto" : "",
      Graded: card.Graded === 1 ? "Graded" : "Raw",
    };
  }
const { state } = useSport();
  
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => {
    if (
      !translations.ModalViewSelectedSales[key] ||
      !translations.ModalViewSelectedSales[key][currentLang]
    ) {
      console.error(
        `Missing translation for key: ${key} in language: ${currentLang}`
      );
      return key;
    }
    return translations.ModalViewSelectedSales[key][currentLang];
  };
  const isViewMode = mode === "view";
  const [yourCash, setYourCash] = useState(0);
  const [theirCash, setTheirCash] = useState(0);
  const [comment, setComment] = useState("");
  const [theirCollection, setTheirCollection] = useState([]);
  const [theirCards, setTheirCards] = useState([]);

  const [yourCollection, setYourCollection] = useState([]);
  const [yourCards, setYourCards] = useState([]);
  const [showAddCardFrom, setShowAddCardFrom] = useState("");


  const [viewMode, setViewMode] = useState(mode);
  const [isACounter, setIsACounter] = useState(false);
  const [transactionId, setTransactionId] = useState(0);

  useEffect(() => {
    if (yourId && yourCollection.length === 0) {
      fetchYourTradeCards();
    }
  }, [yourId, yourCollection.length]); // 👈 add collection length

  useEffect(() => {
    if (theirId && theirCollection.length === 0) {
      fetchTheirTradeCards();
    }
  }, [theirId, theirCollection.length]); // 👈 add collection length

  

 useEffect(() => {
   if (!yourId) { triggerLogin(); }
 }, [yourId, triggerLogin]);

 useEffect(() => {
   if (!isOpen) return;
   setViewMode(mode);       // back to "view" each open
   setIsACounter(false);
   setComment("");
 }, [isOpen, mode, offer]);

  const fetchYourTradeCards = async () => {
    try {
       const sport = state?.sport || "Hockey";

      const res = await fetch(
        `${process.env.REACT_APP_API_BASE}/getUserCards/${yourId}?sport=${encodeURIComponent(sport)}`
     , {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
      const json = await res.json();
      // console.log("Fetching YOUR cards...", json);
      setYourCollection(json);
    } catch (error) {
      console.log("Error fetching card data:", error);
    }
  };

  const fetchTheirTradeCards = async () => {
    try {
       const sport = state?.sport || "Hockey";

      const res = await fetch(
        `${process.env.REACT_APP_API_BASE}/getUserCards/${theirId}?sport=${encodeURIComponent(sport)}`
      , {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
      const json = await res.json();
      // console.log("Fetching THEIR cards...", json);
      setTheirCollection(json);
    } catch (error) {
      console.log("Error fetching card data:", error);
    }
  };
  const {
    mappedOfferData,
    mappedWantedData,
    isViewingUserTheWanted,
    yourCardsToDisplay,
    theirCardsToDisplay,
  } = useMemo(() => {
    if (!isViewMode || !offer) {
      return {
        mappedOfferData: [],
        mappedWantedData: [],
        isViewingUserTheWanted: false,
        yourCardsToDisplay: [],
        theirCardsToDisplay: [],
      };
    }

    const mappedOfferData =
      offer.offerData?.map((card) => mapTradeCard(card, "Offer")) || [];
    const mappedWantedData =
      offer.wantedData?.map((card) => mapTradeCard(card, "Wanted")) || [];

    const isViewingUserTheWanted =
      (Array.isArray(mappedWantedData) &&
        mappedWantedData[0]?.wantedUserId === yourId) ||
      (Array.isArray(mappedOfferData) &&
        mappedOfferData[0]?.wantedUserId === yourId);

    return {
      mappedOfferData,
      mappedWantedData,
      isViewingUserTheWanted,
      yourCardsToDisplay: isViewingUserTheWanted
        ? mappedOfferData
        : mappedWantedData,
      theirCardsToDisplay: isViewingUserTheWanted
        ? mappedWantedData
        : mappedOfferData,
    };
  }, [isViewMode, offer, yourId]);
  useEffect(() => {
    if (mode !== "view") {
      //  console.log('dans le useeffect thisCurrentCard',thisCurrentCard)
      setTheirCards(thisCurrentCard ? thisCurrentCard : []);
      return;
    }

    if (
      !offer ||
      !Array.isArray(offer.offerData) ||
      !Array.isArray(offer.wantedData)
    ) {
      return;
    }

    const mappedOfferData = offer.offerData.map((card) =>
      mapTradeCard(card, "Offer")
    );
    const mappedWantedData = offer.wantedData.map((card) =>
      mapTradeCard(card, "Wanted")
    );

    const isUserTheWanted = mappedWantedData[0]?.wantedUserId === yourId;
    //  console.log('mappedOfferData',mappedOfferData,'mappedWantedData',mappedWantedData)
    setYourCash(isUserTheWanted ? offer.offerCash : offer.wantedCash);
    setTheirCash(isUserTheWanted ? offer.wantedCash : offer.offerCash);
    
    const firstId =
      mappedOfferData?.[0]?.tradeId || mappedWantedData?.[0]?.tradeId;
    if (firstId) {
      setTransactionId(firstId);
    } else {
      console.warn(
        "🚨 No valid tradeId found in mappedOfferData or mappedWantedData"
      );
    }
    console.log(
      "transaction.id",
      mappedOfferData[0]?.tradeId || mappedWantedData[0]?.tradeId
    );
    setYourCards(isUserTheWanted ? mappedOfferData : mappedWantedData);
    setTheirCards(isUserTheWanted ? mappedWantedData : mappedOfferData);
  }, [mode, offer, yourId, thisCurrentCard]);

  // if (!offer || !Array.isArray(offer.wantedData) || !Array.isArray(offer.offerData)) {
  // return <div style={{ color: 'red', padding: '1rem' }}>❌ Error: Missing or invalid trade data.</div>;
  // }


  
  function triggerOnClickX(index, who) {
    // console.log('it got triggered')
    if (who === "yours") {
      const updated = [...yourCards];
      updated.splice(index, 1);
      setYourCards(updated);
    } else if (who === "theirs") {
      const updated = [...theirCards];
      updated.splice(index, 1);
      setTheirCards(updated);
    }
  }

  const cancelXIcon = (index, who) => {
    return (
      <span
        style={{ height: "auto" }}
        onClick={(event) => {
          event.preventDefault();
          triggerOnClickX(index, who);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="#000"
          version="1.1"
          viewBox="0 0 128 128"
          xmlSpace="preserve"
        >
          <g>
            <path
              fill="#0066FFED"
              d="M64 0C28.656 0 0 28.656 0 64s28.656 64 64 64 64-28.656 64-64S99.344 0 64 0zm0 120C33.125 120 8 94.875 8 64S33.125 8 64 8s56 25.125 56 56-25.125 56-56 56z"
            ></path>
            <path
              fill="#F44336"
              d="M75.313 64l16.969-16.969c3.125-3.125 3.125-8.195 0-11.313-3.117-3.125-8.188-3.125-11.313 0L64 52.688 47.031 35.719c-3.125-3.125-8.195-3.125-11.313 0-3.125 3.117-3.125 8.188 0 11.313L52.688 64 35.719 80.969c-3.125 3.125-3.125 8.195 0 11.313 3.117 3.125 8.188 3.125 11.313 0L64 75.313l16.969 16.969c3.125 3.125 8.195 3.125 11.313 0 3.125-3.117 3.125-8.188 0-11.313L75.313 64z"
            ></path>
          </g>
        </svg>
      </span>
    );
  };

async function completeTrade(tradeId) {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_BASE}/api/trades/${tradeId}/complete`,
      {},
      { withCredentials: true }
    );

    if (data.success) {
      // Optional: optimistic move to "Completed" tab
      toast.success(data.alreadyCompleted ? t('Trade already completed') : t('Trade marked as completed'));
        fetchTradeOffers();
        onClose();
    } else {
      toast.error(data.error || 'Could not complete trade');
    }
  } catch (err) {
    console.error('completeTrade error', err);
    toast.error(t('Network error while completing trade'));
  }
}

  const handleAccept = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/tradePlace/acceptOffer`,
        {
          thisUserId: theirId,
          otherUserId: yourId,
          tradeId: transactionId,
          comment
        },
        { withCredentials: true }
      );
      if (res.data.success) {
        toast.success(t("TradeAccepted"));
        fetchTradeOffers();
        onClose();
      } else {
        toast.error(t("TradeAcceptFailed"));
      }
    } catch (err) {
      console.error(err);
      toast.error(t("TradeAcceptFailed"));
    }
  };

  //DOit switch les users Car le thisUser est celui qui fait la demande - alors qu<ici on repond
  const handleRefuse = async () => {
    try {
      console.log("prerefuse", transactionId);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/tradePlace/rejectOffer`,
        {
          thisUserId: theirId,
          otherUserId: yourId,
          tradeId: transactionId,
          comment, 
        },
        { withCredentials: true }
      );
      if (res.data.success) {
        toast.success(t("TradeRejected"));
        fetchTradeOffers();
        onClose();
      } else {
        toast.error(t("TradeRejectFailed"));
      }
    } catch (err) {
      console.error(err);
      toast.error(t("TradeRejectFailed"));
    }
  };


  const startCounterOffer = () => {
    setYourCards(mappedWantedData); // You are giving what they wanted
    setTheirCards(mappedOfferData);
    setIsACounter(true); // You are requesting what they offered
    setViewMode("");
    const newTheirCash = theirCash;
    const newYourCash = yourCash;
    setYourCash(newTheirCash);
    setTheirCash(newYourCash); // Open modal in editable mode
  };
  const handleCounter = async () => {
    try {
      const res = await axios.post(
       `${process.env.REACT_APP_API_BASE}/api/tradePlace/counteredOffer`,
        {
          thisUserId: theirId,
          otherUserId: yourId,
          tradeId: transactionId,
        },
        { withCredentials: true }
      );
      if (res.data.success) {
        toast.success(t("TradeCountered"));
        fetchTradeOffers();
        onClose();
      } else {
        toast.error(t("TradeCounterFailed"));
      }
    } catch (err) {
      console.error(err);
      toast.error(t("TradeCounterFailed"));
    }
  };

  function buildCardDataArray(cards) {
    console.log("cards", cards);
    return cards.map((card) => ({ userCardId: card.userCardId || card.id }));
  }

  async function submitTradeOffer() {
    const givingData = buildCardDataArray(yourCards);
    const receivingData = buildCardDataArray(theirCards);
    console.log("givingData", givingData, "receivingData", receivingData);
    const givingCashDouble =
      parseFloat(String(yourCash).replace(",", ".")) || 0;
    const receivingCashDouble =
      parseFloat(String(theirCash).replace(",", ".")) || 0;

    if (isNaN(givingCashDouble) || isNaN(receivingCashDouble)) {
      toast.error("Invalid cash value");
      return;
    }

    const requestData = {
      thisUserId: yourId,
      offerData: givingData,
      offerCash: givingCashDouble,
      otherUserId: theirId,
      wantedData: receivingData,
      wantedCash: receivingCashDouble,

      comments: comment,

      IsItACounterOffer: isACounter,
      liveCsrfToken: liveCsrfToken,
    };
    console.log("requestData", requestData);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/tradePlace/submitTradeOffer`,
        requestData,
        { withCredentials: true }
      );

      if (response.data.success) {
        toast.success(t("TradeOfferSubmittedSuccess"));
        if (isACounter) {
          handleCounter();
        }
        //onSubmit(requestData);

     
        onClose();
      } else {
        toast.error(t("TradeOfferSubmissionFailed"));
      }
    } catch (error) {
      console.error("Error submitting trade offer:", error);
      toast.error(t("TradeOfferSubmissionError"));
    }
  }


 const closeModal = onClose;

  const TradeTransactionCommentFeedWrapper = ({ offer }) => {
    if (!offer) return null;
  
    const trade =
      Array.isArray(offer.wantedData) && offer.wantedData.length > 0
        ? offer.wantedData[0]
        : offer.offerData?.[0]; // use optional chaining just in case
  
    if (!trade) return null;
    const hasAnyComment =
    trade?.comments || trade?.acceptedComments || trade?.rejectedComments;
  
    return (
      <>
        {hasAnyComment && (
          <div className="ship-now-section">
            <TradeTransactionCommentFeed trade={trade} t={t}/>
          </div>
        )}
      </>
    );
  };

  return (
    <div onClick={(e)=>e.stopPropagation()}>
      {/* {viewMode === "view" ? (
        <button onClick={openModal} className="btn-baseBlue full-right-side">
          {t("View")}
        </button>
      ) : null} */}

      <Modal
        
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="modal-container NoLimit"
        overlayClassName="modal-overlay"
        style={{ width: "100%", height: "100%", maxWidth: "none" }}
        
      >
        {viewMode === "view" ? (
          <div
            className="modal-offer-container"
            style={{ width: "100%", height: "100%", maxWidth: "none" }}
            onClick={(e)=>e.stopPropagation()}
          >
            <div className="offer-section-selected">
              <div className="offer-column giving-section">
                <h2 className="section-title-selected">{t("You receive")}</h2>
                <p>
                  <div className="cash-summary">
                    <span className="cash-label">{t("Cash Included")}:</span>
                    {/* <span className="cash-amount">  +${yourCash}</span> */}
                    <span
                      className={`cash-amount ${
                        yourCash > 0
                          ? "cash-positive"
                          : yourCash < 0
                          ? "cash-negative"
                          : ""
                      }`}
                    >
                       {yourCash > 0 ? "+" : yourCash < 0 ? "-" : ""}$
                      {Math.abs(yourCash)}
                    </span>
                  </div>
                </p>
                <div className="card-list">
                  {yourCards?.map((card, index) => (
                    <div key={index} className="card-container">
                      <BigShowCompleteCard
                        formData={card}
                        isForCreate={false}
                        useMinHeight={false}
                        showPrice={true}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div className="offer-column receiving-section">
                <h2 className="section-title-selected">{t("You give")}</h2>
                <p>
                  <div className="cash-summary">
                    <span className="cash-label">{t("Cash Included")}:</span>
                    {/* <span className="cash-amount">  +${theirCash}</span> */}
                    <span
                      className={`cash-amount ${
                        theirCash > 0
                          ? "cash-negative"
                          : theirCash < 0
                          ? "cash-positive"
                          : ""
                      }`}
                    >
                       {theirCash > 0 ? "-" : theirCash < 0 ? "+" : ""}$
                      {Math.abs(theirCash)}
                    </span>
                  </div>
                </p>
                <div className="card-list">
                  {theirCards?.map((card, index) => (
                    <div key={index} className="card-container">
                      <BigShowCompleteCard
                        formData={card}
                        isForCreate={false}
                        useMinHeight={false}
                        showPrice={true}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="action-section">
              {/* <label className="comment-label">
                {t("Comment")}
                <textarea
                  value={offer?.comments}
                  // onChange={handleCommentChange}
                  maxLength={398}
                  rows={6}
                  cols={30}
                  placeholder={t("Write a comment for the seller")}
                />
              </label> */}


{offer && <TradeTransactionCommentFeedWrapper offer={offer} />}

              {isViewingUserTheWanted && (Status==="Waiting" || Status==="Counter") && (
               
               <><label className="comment-label">
                {t("Message (optional)")}
                <textarea
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  maxLength={398}
                  rows={5}
                  placeholder={t("Write a message to accompany your decision...")}
                />
              </label>


                <div className="button-group">
                  <button
                    className="btn-confirm"
                    onClick={() => handleAccept()}
                  >
                    {t("Accept")}✔️
                  </button>
                  <button className="btn-reject" onClick={() => handleRefuse()}>
                    {t("Reject")}❌
                  </button>
                  <button
                    className="btn-counter"
                    onClick={() => startCounterOffer()}
                  >
                    {t("Counter Offer")}🔁
                  </button>
                </div> </>
              )}

{Status === 'Accepted' && (
  <div className="trade-actions">
    {/* {!trade.offerReceivedDate && currentUserId === trade.offerUserId && (
      <button className="btn-ghost" onClick={() => apiMarkReceived(trade.tradeId)}>
        {t("I received my cards")}
      </button>
    )}
    {!trade.wantedReceivedDate && currentUserId === trade.wantedUserId && (
      <button className="btn-ghost" onClick={() => apiMarkReceived(trade.tradeId)}>
        {t("I received my cards")}
      </button>
    )} */}

    {/* <button className="btn-danger" onClick={() => openCancelModal(trade.tradeId)}>
      {t("Cancel trade")}
    </button> */}

    <button className="btn-primary" onClick={() => completeTrade(transactionId)}>
      {t("Mark trade as completed")}
    </button>
  </div>
)}

{/* {showCancel && (
  <Modal onRequestClose={closeCancel} >
    <h3>{t("Cancel trade")}</h3>
    <label className="field">
      {t("Reason")}
      <select value={reasonKey} onChange={e=>setReasonKey(e.target.value)}>
        <option value="no_longer_interested">{t("No longer interested")}</option>
        <option value="could_not_ship">{t("Could not ship on time")}</option>
        <option value="found_issue">{t("Found an issue with a card")}</option>
        <option value="other">{t("Other")}</option>
      </select>
    </label>
    {reasonKey === 'other' && (
      <textarea value={reasonText} onChange={e=>setReasonText(e.target.value)} maxLength={255} />
    )}
    <div className="modal-actions">
      <button onClick={closeCancel}>{t("Back")}</button>
      <button className="btn-danger" onClick={() =>
        apiCancel(tradeId, reasonKey === 'other' ? reasonText : reasonKey)
      }>
        {t("Confirm cancel")}
      </button>
    </div>
  </Modal>
)} */}
              {/* {Status === 'Accepted' && (
  <button className="btn-primary" onClick={() => completeTrade(transactionId)}>
    {t('Mark trade as completed')}
  </button>
)} */}

              <button
                style={{ marginTop: "10px" }}
                className="btn-close"
                onClick={() => {
                  
                  onClose();
                }}
              >
                {t("Close")}
              </button>
            </div>
          </div>
        ) : showAddCardFrom === "" ? (
          <div
            className="modal-offer-container"
            style={{ width: "100%", height: "100%", maxWidth: "none" }}
          >
            <div className="offer-section-selected">
              <div className="offer-column giving-section">
                <h2 className="section-title-selected">
                  {t("You give")} ({yourCards.length})
                </h2>
                <div className="add-cash-section">
                  {/* <label>{t("Add Cash")}$</label>
                  <input
                    type="number"
                    className="cash-input"
                    value={yourCash}
                    onChange={(e) => setYourCash(e.target.value)}
                    placeholder="$0"
                  /> */}
                  <div className="cash-input-wrapper">
                    <label className="cash-label">{t("Add Cash")} 💸</label>
                    <input
                      type="number"
                      value={yourCash}
                      onChange={(e) => setYourCash(e.target.value)}
                      className="cash-input"
                      placeholder="e.g. 0"
                    />
                  </div>
                  <button
                    className="btn-baseBlue"
                    style={{ marginLeft: "2vw" }}
                    onClick={() => setShowAddCardFrom("yourCollection")}
                  >
                    {t("Add Cards")}
                  </button>
                </div>
                <div className="card-list">
                  {yourCards.map((card, index) => (
                    <div
                      key={index}
                      className="card-container"
                      style={{ position: "relative" }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "4px",
                          right: "4px",
                          zIndex: 2,
                          cursor: "pointer",
                        }}
                      >
                        {cancelXIcon(index, "yours")}
                      </div>
                      <BigShowCompleteCard
                        formData={card}
                        isForCreate={false}
                        useMinHeight={false}
                        showPrice={true}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div className="offer-column receiving-section">
                <h2 className="section-title-selected">
                  {t("You receive")} ({theirCards.length})
                </h2>
                <div className="add-cash-section">
                  {/* <label>{t("Add Cash")}$</label>
                  <input
                    type="number"
                    className="cash-input"
                    value={theirCash}
                    onChange={(e) => setTheirCash(e.target.value)}
                    placeholder="$0"
                  /> */}
                  <div className="cash-input-wrapper">
                    <label className="cash-label">{t("Add Cash")} 💸</label>
                    <input
                      type="number"
                      value={theirCash}
                      onChange={(e) => setTheirCash(e.target.value)}
                      className="cash-input"
                      placeholder="e.g. 0"
                    />
                  </div>
                  <button
                    className="btn-baseBlue"
                    style={{ marginLeft: "2vw" }}
                    onClick={() => setShowAddCardFrom("theirCollection")}
                  >
                    {t("Add Cards")}
                  </button>
                </div>
                <div className="card-list">
                  {theirCards.map((card, index) => (
                    <div
                      key={index}
                      className="card-container"
                      style={{ position: "relative" }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "4px",
                          right: "4px",
                          zIndex: 2,
                          cursor: "pointer",
                          width: "28px",
                          height: "28px",
                          //display: "flex",
                          // alignItems: "center",
                          // justifyContent: "center",
                          borderRadius: "50%",
                          backgroundColor: "rgba(0, 0, 0, 0.8)",
                          transition: "background 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor =
                            "rgba(255, 0, 0, 0.8)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor =
                            "rgba(0, 0, 0, 0.8)";
                        }}
                      >
                        {cancelXIcon(index, "theirs")}
                      </div>
                      <BigShowCompleteCard
                        formData={card}
                        isForCreate={false}
                        useMinHeight={false}
                        showPrice={true}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="action-section">
              <label className="comment-label">
                {t("Comment")}
                <textarea
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  maxLength={398}
                  rows={6}
                  cols={30}
                  placeholder={t("Write a comment for the seller")}
                />
              </label>

              <div className="button-group">
                <button className="btn-confirm" onClick={submitTradeOffer}>
                  {t("Submit Offer")}
                </button>
                <button
                  className="btn-close"
                  onClick={() => {
                    
                    onClose();
                  }}
                >
                  {t("Close")}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <>
            <button
              className="btn-baseBlue"
              onClick={() => setShowAddCardFrom("")}
              style={{marginBottom:'10px'}}
            >
              {t("Go Back")}
            </button>
            {["yourCollection", "theirCollection"].includes(
              showAddCardFrom
            ) && (
              <section className="grid">
                <div className="contentfront">
                  <FullCardGrid
                    setCards={
                      showAddCardFrom === "yourCollection"
                        ? setYourCollection
                        : setTheirCollection
                    }
                    cards={
                      showAddCardFrom === "yourCollection"
                        ? yourCollection
                        : theirCollection
                    }
                    groupedCards={[]}
                    viewAsGrid={false}
                    viewOnly={true}
                    cardGridType={"CardGridSell"}
                    MultiCardOfferSelection={true}
                    SetMultiCardOfferSelection={
                      showAddCardFrom === "yourCollection"
                        ? setYourCards
                        : setTheirCards
                    }
                    preSelectedCards={
                      showAddCardFrom === "yourCollection"
                        ? yourCards.map((c) => c.id || c.usercardId)
                        : theirCards.map((c) => c.id || c.usercardId)
                    }
                    setModal={() => setShowAddCardFrom("")}
                  />
                </div>
              </section>
            )}
          </>
        )}
      </Modal>
    </div>
  );
};

export default ModalTradeOffer;
